(function () {
  var count = 0;

  function paint() {
    var text = count > 0 ? String(count) : '';
    [].slice.call(document.querySelectorAll('.cart-count-inline')).forEach(function (el) {
      if (el.textContent !== text) el.textContent = text;
    });
  }

  function refresh() {
    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) {
        return r.json();
      })
      .then(function (cart) {
        count = cart.item_count || 0;
        paint();
      })
      .catch(function () {});
  }

  refresh();

  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.cartUpdate, function (event) {
      if (event && event.cartData && typeof event.cartData.item_count === 'number') {
        count = event.cartData.item_count;
        paint();
      } else {
        refresh();
      }
    });
  }

  // The cart drawer re-renders the header link after each change: paint again.
  var bubble = document.getElementById('cart-icon-bubble');
  if (bubble && 'MutationObserver' in window) {
    new MutationObserver(paint).observe(bubble, { childList: true, subtree: true });
  }

  window.addEventListener('pageshow', refresh);
})();
